(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaj-complete-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  class GajCompleteLook extends HTMLElement {
    connectedCallback(){this.controller=new AbortController();document.addEventListener('gaj:variant-selected',event=>{const metal=event.detail.options.find(option=>/gold|platinum/i.test(option));if(metal)this.querySelectorAll('gaj-shopping-card').forEach(card=>card.selectMetal?.(metal));},{signal:this.controller.signal});}
    disconnectedCallback(){this.controller?.abort();}
  }
  if(!customElements.get('gaj-complete-look'))customElements.define('gaj-complete-look',GajCompleteLook);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaj-mens-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-gaj-men] [data-gaj-metal]');
  if (!button) return;
  const card = button.closest('.gaj-men__card');
  const image = card.querySelector('.gaj-men__product-image');
  if (image && button.dataset.image) {
    image.removeAttribute('srcset');
    image.src = button.dataset.image;
    image.alt = card.querySelector('h2').textContent.trim() + ' — ' + button.dataset.label;
  }
  card.querySelectorAll('[data-gaj-product-link]').forEach(link => { link.href = button.dataset.url; });
  card.querySelectorAll('[data-gaj-metal]').forEach(item => { item.setAttribute('aria-pressed', String(item === button)); });
  card.querySelector('.gaj-men__selected').textContent = button.dataset.label;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaj-shop-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-gaj-shop] [data-gaj-metal]');
  if (!button) return;
  const card = button.closest('.gaj-shop__card');
  const image = card.querySelector('.gaj-shop__product-image');
  if (image && button.dataset.image) {
    image.removeAttribute('srcset');
    image.src = button.dataset.image;
    image.alt = card.querySelector('h2').textContent.trim() + ' — ' + button.dataset.label;
  }
  card.querySelectorAll('[data-gaj-product-link]').forEach(link => { link.href = button.dataset.url; });
  card.querySelectorAll('[data-gaj-metal]').forEach(item => { item.setAttribute('aria-pressed', String(item === button)); });
  card.querySelector('.gaj-shop__selected').textContent = button.dataset.label;
  card.querySelector('.gaj-shop__price').textContent = button.dataset.price;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
function gajSyncCollectionLinks(event) {
  const option = event.target.closest('pcard-swatch');
  if (!option) return;
  const card = option.closest('[data-gaj-gold-card]');
  if (!card) return;
  requestAnimationFrame(function() {
    const variantInput = card.querySelector('input[name="id"]');
    if (!variantInput || !/^\d+$/.test(variantInput.value)) return;
    card.querySelectorAll('[data-gaj-product-link]').forEach(function(link) {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantInput.value);
      link.href = url.toString();
    });
    card.querySelectorAll('input[name="id"]').forEach(function(input) {
      input.value = variantInput.value;
      input.dataset.selectedVariant = variantInput.value;
    });
  });
}
document.addEventListener('click', gajSyncCollectionLinks);
document.addEventListener('change', gajSyncCollectionLinks);

  } catch(e) { console.error(e); }
})();
})();
